

































import { Component, Vue } from "vue-property-decorator";
import { serialiseConfig } from "@/helpers/table";
import { FilterOperators, Sorters } from "@/data/table";
import { TicketStatusCodes } from "@/data/enums/tickets";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import { IState } from "@/store";

@Component({
  components: {
    "tickets-table": () =>
      import("@/components/app/global/tickets/ticketsTable.vue"),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class ClientTickets extends Vue {
  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.SUPPORT_OVERVIEW,
      objectId: (this.$store.state as IState).user?.id
    };
  }

  public get routes() {
    return [
      {
        label: this.$t("_.active_tickets"),
        exact: true,
        to: { name: "clientSupportTickets" }
      },
      {
        label: this.$t("_.closed_tickets"),
        exact: true,
        to: {
          name: "clientSupportTickets",
          query: {
            CTT1: serialiseConfig({
              constFilters: [
                {
                  key: "status.code",
                  operator: FilterOperators.EQUAL,
                  value: TicketStatusCodes.CLOSED
                }
              ],
              sort: {
                field: "updated_at",
                direction: Sorters.DESCENDING
              }
            })
          }
        }
      }
    ];
  }
}
